import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { type FeatureOptInMode, type ITelemetryItem } from '@microsoft/applicationinsights-core-js';
import { useUserStore } from '@/plugins/pinia/userStore.ts';

const createApplicationInsights = () => {
  const user = useUserStore();

  const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;
  if (!connectionString) {
    console.warn('Application Insights connection string was not found.');
    return undefined;
  }

  const apiHost = new URL(import.meta.env.VITE_API_BASE_URL).host;

  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      correlationHeaderDomains: [apiHost],
      disablePageUnloadEvents: ['unload'],
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      excludeRequestFromAutoTrackingPatterns: [/https:\/\/.*\.googletagmanager\.com\//],
      featureOptIn: { sdkStats: { mode: 2 satisfies FeatureOptInMode.disable } },
    },
  });

  appInsights.loadAppInsights();
  appInsights.context.application.ver = import.meta.env.VITE_BUILD_VERSION;

  appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
    envelope.tags = envelope.tags || {};
    if (!user.analyticsConsent && user.cookieConsent?.analytics === false) {
      envelope.tags['ai.location.ip'] = '0.0.0.0';
    }
    envelope.tags['ai.cloud.role'] = 'public-ui';
  });

  console.log('Application Insights initialized.');

  return appInsights;
};

export const installApplicationInsights = (): ApplicationInsights | undefined => createApplicationInsights();
